<div class="rh-page">
  @if (isArchived()) {
    <app-projekt-archiviert-hinweis class="rh-archiviert-hinweis" />
  }
  <div class="rh-header">
    <div class="rh-header__titles">
      <div class="rh-eyebrow">{{ 'requirements.history.eyebrow' | translate }}</div>
      <h1 class="rh-title">
        {{ 'requirements.history.title' | translate }} ·
        <code class="rh-title__key">{{ requirementKey }}</code>
      </h1>
      <div class="rh-subtitle">
        {{ 'requirements.history.summary' | translate: { count: totalCount() } }}
      </div>
    </div>
    <div class="rh-actions">
      <button type="button" class="rh-action" [disabled]="exporting() || totalCount() === 0" (click)="exportCsv()">
        <mat-icon aria-hidden="true">file_download</mat-icon>
        {{ 'requirements.history.exportCsv' | translate }}
      </button>
      <button type="button" class="rh-action" disabled [title]="'requirements.history.notifyDisabledHint' | translate">
        <mat-icon aria-hidden="true">notifications_none</mat-icon>
        {{ 'requirements.history.notify' | translate }}
      </button>
    </div>
  </div>

  <div class="rh-filters" role="tablist" [attr.aria-label]="'requirements.history.filterLabel' | translate">
    <span class="rh-filters__label">{{ 'requirements.history.filter' | translate }}</span>
    @for (f of filters; track f.id) {
      <button
        type="button"
        role="tab"
        class="rh-chip"
        [class.rh-chip--active]="activeFilter() === f.id"
        [attr.aria-selected]="activeFilter() === f.id"
        (click)="setFilter(f.id)"
      >
        {{ f.labelKey | translate }}
        <span class="rh-chip__count">{{ counts()[f.id] }}</span>
      </button>
    }
  </div>

  @if (loading()) {
    <div class="rh-state" role="status">
      <mat-progress-spinner mode="indeterminate" [diameter]="28" />
    </div>
  } @else if (loadError()) {
    <div class="rh-state rh-state--error" role="alert">
      {{ 'requirements.history.loadError' | translate }}
    </div>
  } @else if (visibleItems().length === 0) {
    <div class="rh-state rh-state--empty">
      {{ 'requirements.history.empty' | translate }}
    </div>
  } @else {
    <ol class="rh-timeline" [attr.aria-label]="'requirements.history.title' | translate">
      @for (item of visibleItems(); track $index) {
        <li class="rh-event">
          <span
            class="rh-event__marker rh-event__marker--{{ variant(item.type) }}"
            role="img"
            [attr.aria-label]="'requirements.history.types.' + item.type | translate"
          >
            <mat-icon aria-hidden="true">{{ icon(item.type) }}</mat-icon>
          </span>
          <div class="rh-event__body">
            @let displayUser = item.user || ('common.unknownUser' | translate);
            <div class="rh-event__head">
              <app-avatar [name]="displayUser" [size]="20" aria-hidden="true" />
              <strong class="rh-event__user">{{ displayUser }}</strong>
              <span class="rh-event__action">{{ 'requirements.history.types.' + item.type | translate }}</span>
              @if (item.field) {
                <span class="rh-event__field">
                  {{ item.fieldKey ? (item.fieldKey | translate: item.fieldParams) : item.field }}
                </span>
              }
              <time class="rh-event__time" [attr.datetime]="item.createdAt">
                {{ item.createdAt | date: 'dd.MM.yyyy, HH:mm' }}
              </time>
            </div>
            @let hasFrom = item.from || item.fromKey;
            @let hasTo = item.to || item.toKey;
            @if (hasFrom || hasTo) {
              <div class="rh-diff">
                @if (hasFrom) {
                  <span class="rh-diff__from" [class.rh-diff__from--plain]="item.from === '—'">
                    {{ item.fromKey ? (item.fromKey | translate) : item.from }}
                  </span>
                }
                @if (hasFrom && hasTo) {
                  <span class="rh-diff__arrow" aria-hidden="true">→</span>
                }
                @if (hasTo) {
                  <span class="rh-diff__to">{{ item.toKey ? (item.toKey | translate) : item.to }}</span>
                }
              </div>
            }
          </div>
        </li>
      }
    </ol>
    @if (truncated()) {
      <p class="rh-truncated" role="status">{{ 'requirements.history.truncated' | translate }}</p>
    }
  }
</div>
